import styles from "../../leaderboard.module.css";
import { Dropdown } from "react-bootstrap";
import { Archive, ArrowLeft, ArrowRight, Bell, Check, CheckCircle, ChevronDown, ChevronsLeft, Copy, Edit, Flag, Link, Mail, MoreVertical, PhoneCall, Send, Trash2, X } from "react-feather";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { TableLoader } from "../../../../../components/LoaderC";
import { useDispatch, useSelector } from "react-redux";
import { setConversationId } from "../../../../../redux/actions/communicationConversationId";
import CopyToClipboard from "react-copy-to-clipboard";
import { Link as LinkTo } from "react-router-dom";
import SimpleTabs from "./components/SimpleTabs";
import { communicationChatReload } from "../../../../../redux/actions/communicationChatRloadAction";
import dayjs from "dayjs";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddTourTileSlot from "../../../Components/AddTourTileSlot";
import { AddLogCallAPI } from "../../../../../components/AddLogs";
import EditPropsectNew from "../../../Components/EditPropspectNew";
import LeaseForm from "../../../Components/LeaseForm";
import AddFollowUp from "../../../Components/follow-up/AddFollowUp";

const ProspectDetails = ({ prospect_id, setOpenProspectDetails, setOpenCallModal, setProspectInfoObj, setLoading }) => {
    const voiceCallInfo = useSelector((store) => store.communicationVoiceCallInfoReducer);
    const dispatch = useDispatch();
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [prospectData, setProspectData] = useState(null);
    const [currentApplicant, setCurrentApplicant] = useState(0);
    const [currentApplicantData, setCurrentApplicantData] = useState(null);
    const [emailCopied, setEmailCopied] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [isConnectAccountModalOpen, setIsConnectAccountModalOpen] = useState(false);
    const [addTourModalOpen, setAddTourModalOpen] = useState(false);
    const [editTourData, setEditTourData] = useState(null);
    const [tourTimeSlotError, setTourTimeSlotError] = useState("");
    const [selectedApartment, setSelectedApartment] = useState("");
    const [tourAptSlotError, setTourAptSlotError] = useState("");
    const [selectedTourDate, setSelectedTourDate] = useState(dayjs());
    const [selectedTourTime, setSelectedTourTime] = useState("");
    const [apartments, setApartments] = useState([]);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [isVerifyLinkModalOpen, setIsVerifyLinkModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [archiveModalOpen, setArchiveModalOpen] = useState(false);
    const [applicationModalOpen, setApplicationModalOpen] = useState(false);
    const [addLeaseModalOpen, setAddLeaseModalOpen] = useState(false);
    const [leaseFormData, setLeaseFormData] = useState(null);
    const [completedTaskPercent, setCompletedTaskPercent] = useState('0');
    const [openStepperDetails, setOpenStepperDetails] = useState(false);
    const [currentTaskList, setCurrentTaskList] = useState('');
    const [maxiDetails, setMaxiDetails] = useState(false);
    const [isAppliedModalOpen, setIsAppliedModalOpen] = useState(false);
    const [isScreenedModalOpen, setIsScreenedModalOpen] = useState(false);
    const [isApprovedModalOpen, setIsApprovedModalOpen] = useState(false);
    const [isDeclinedModalOpen, setIsDeclinedModalOpen] = useState(false);
    const [followUpList, setFollowUpList] = useState([]);
    const [followUpEditData, setFollowUpEditData] = useState(null);
    const [openFollowUpModal, setOpenFollowUpModal] = useState(false);

    const OpenMaxiDetails = () => {
        setMaxiDetails(true);
    };
    const CloseMaxiDetails = () => {
        setMaxiDetails(false);
    };

    useEffect(() => {
        const fetchProspect = async () => {
            setContentLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/" + prospect_id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setProspectData(response.data.data);

                setFollowUpList(response?.data?.data?.follow_ups);

            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
                setContentLoading(false);
            });
        };
        if (prospect_id)
            fetchProspect();
    }, [prospect_id, getAccessTokenSilently]);

    useEffect(() => {
        if (prospectData) {
            let cApp = 0;
            prospectData?.all_applicants?.map((i, ind) => {
                if (parseInt(i?.id) === parseInt(prospect_id)) {
                    cApp = ind;
                }
                return false;
            });
            setCurrentApplicant(cApp);
        }
    }, [prospectData, prospect_id]);

    useEffect(() => {
        setCurrentApplicantData(prospectData?.all_applicants[currentApplicant]);
    }, [prospectData, currentApplicant]);

    useEffect(() => {
        async function fetchApartment() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/apartments/" + prospectData?.property_id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setApartments(response?.data?.data);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        }
        if (prospectData?.property_id) {
            fetchApartment();
        }
    }, [prospectData?.property_id, getAccessTokenSilently]);

    const openProspectConversation = (e, currentApplicantData) => {
        const { conversation_id } = currentApplicantData;
        e.preventDefault();
        dispatch(setConversationId(conversation_id));
    }

    const initiateVoiceCall = (item) => {
        if (voiceCallInfo) {
            toast.error("You are on anotehr call.");
        } else {
            setOpenCallModal(true);
            setProspectInfoObj({ id: currentApplicantData?.id, full_name: currentApplicantData?.full_name, initial: currentApplicantData?.initial, phone: currentApplicantData?.phone, user_avatar: currentApplicantData?.user_avatar, type: "Prospect" });
        }
    }

    const addNoteData = (data) => {
        let noteList = prospectData?.notes;
        noteList = [data].concat(noteList);
        setProspectData((prevVal) => {
            return { ...prevVal, notes: noteList };
        });
    }

    const editNoteData = (data, id) => {
        let noteList = prospectData?.notes;
        noteList = noteList.map((item) => {
            if (item.id === id) return data;
            return item;
        });
        setProspectData((prevVal) => {
            return { ...prevVal, notes: noteList };
        });
    }

    const deleteNoteData = (nId) => {
        let noteList = prospectData?.notes;
        noteList = noteList.filter((i) => i?.id !== nId);
        setProspectData((prevVal) => {
            return { ...prevVal, notes: noteList };
        });
    }

    const sendBankAccountLInk = async () => {
        setIsConnectAccountModalOpen(false);
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/send-bank-account-link/" + currentApplicantData?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);
            dispatch(communicationChatReload(true));
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const updateFileList = (files, applicantIndex) => {
        let allApplicants = prospectData?.all_applicants?.map((item) => {
            if (parseInt(item?.id) === parseInt(prospect_id)) {
                return { ...item, files: files };
            }
            return item;
        });
        setProspectData((prevVal) => {
            return { ...prevVal, all_applicants: allApplicants };
        });
    }

    const updateTourList = (tours) => {
        setProspectData((prevVal) => {
            return { ...prevVal, tours: tours };
        });
    }

    const updateMandatoryChecks = (mData) => {
        let allApplicants = prospectData?.all_applicants?.map((item, index) => {
            if (index === 0) {
                if (typeof mData?.credit_background_check_1 !== "undefined") {
                    item = { ...item, credit_background_check: mData?.credit_background_check_1 };
                }
                if (typeof mData?.employement_verification_1 !== "undefined") {
                    item = { ...item, employement_verification: mData?.employement_verification_1 };
                }
                if (typeof mData?.income_verification_1 !== "undefined") {
                    item = { ...item, income_verification: mData?.income_verification_1 };
                }
                if (typeof mData?.landlord_verification_1 !== "undefined") {
                    item = { ...item, landlord_verification: mData?.landlord_verification_1 };
                }
                if (typeof mData?.application_fee_collected_1 !== "undefined") {
                    item = { ...item, application_fee_collected: mData?.application_fee_collected_1 };
                }
            }
            if (index === 1) {
                if (typeof mData?.credit_background_check_2 !== "undefined") {
                    item = { ...item, credit_background_check: mData?.credit_background_check_2 };
                }
                if (typeof mData?.employement_verification_2 !== "undefined") {
                    item = { ...item, employement_verification: mData?.employement_verification_2 };
                }
                if (typeof mData?.income_verification_2 !== "undefined") {
                    item = { ...item, income_verification: mData?.income_verification_2 };
                }
                if (typeof mData?.landlord_verification_2 !== "undefined") {
                    item = { ...item, landlord_verification: mData?.landlord_verification_2 };
                }
                if (typeof mData?.application_fee_collected_2 !== "undefined") {
                    item = { ...item, application_fee_collected: mData?.application_fee_collected_2 };
                }
            }
            return item;
        });

        setProspectData((prevVal) => {
            return { ...prevVal, all_applicants: allApplicants };
        });
    }

    useEffect(() => {
        if (selectedApartment !== "") {
            setTourAptSlotError("");
        }
    }, [selectedApartment]);

    useEffect(() => {
        if (editTourData) {
            setSelectedTourDate(dayjs(editTourData?.datef));
            setSelectedTourTime(editTourData?.timef);
            setSelectedApartment(editTourData?.apt_id);
        } else {
            setSelectedTourDate(dayjs());
            setSelectedTourTime("");
            setSelectedApartment(prospectData?.apt_id);
        }
    }, [editTourData, prospectData?.apt_id]);

    const addTour = async () => {
        if (selectedApartment === "") {
            setTourAptSlotError("Please select apartment.");
            return false;
        }

        if (selectedTourTime === "") {
            setTourTimeSlotError("Please select time slot.");
            return false;
        }
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        let postData = {};
        postData = { ...postData, date_time: dayjs(selectedTourDate).format("YYYY-MM-DD") + " " + selectedTourTime, apt_id: selectedApartment };
        postData = { ...postData, property_id: prospectData?.property_id };

        setLoading(true);
        axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/applicants/" + prospectData?.applicant_id + "/tours", postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setAddTourModalOpen(false);
            setSelectedTourDate(dayjs());
            setSelectedTourTime("");
            setSelectedApartment(prospectData?.apt_id ? prospectData?.apt_id : "");

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let tourlist = prospectData?.tours;
            tourlist.push(response.data.data);
            setProspectData((prevVal) => {
                return { ...prevVal, tours: tourlist };
            });

            dispatch(communicationChatReload(true));

            let logData = {
                title: "A new prospect tour is added",
                description: [
                    "Name: " + prospectData?.all_applicants[0]?.full_name,
                    "Email: " + prospectData?.all_applicants[0]?.email,
                    "Phone: " + prospectData?.all_applicants[0]?.phone,
                    "Date/Time: " + response.data.data?.formatted_date + " " + response.data.data?.formatted_time,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    };

    const updateTour = async () => {
        if (selectedApartment === "") {
            setTourAptSlotError("Please select apartment.");
            return false;
        }

        if (selectedTourTime === "") {
            setTourTimeSlotError("Please select time slot.");
            return false;
        }
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        let postData = {};
        postData = { ...postData, date_time: dayjs(selectedTourDate).format("YYYY-MM-DD") + " " + selectedTourTime, apt_id: selectedApartment };
        postData = { ...postData, property_id: prospectData?.property_id };

        setLoading(true);
        axios.put(process.env.REACT_APP_APPLICANT_API_URL + "v1/applicants/" + prospectData?.applicant_id + "/tours/" + editTourData?.id, postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setAddTourModalOpen(false);
            setSelectedTourDate(dayjs());
            setSelectedTourTime("");
            setSelectedApartment(prospectData?.apt_id ? prospectData?.apt_id : "");

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let tourlist = prospectData?.tours;
            tourlist = tourlist?.map((item) => {
                if (editTourData?.id === item?.id) {
                    return response.data.data;
                }
                return item;
            });
            setProspectData((prevVal) => {
                return { ...prevVal, tours: tourlist };
            });

            dispatch(communicationChatReload(true));

            let logData = {
                title: "A prospect tour is updated",
                description: [
                    "Name: " + prospectData?.all_applicants[0]?.full_name,
                    "Email: " + prospectData?.all_applicants[0]?.email,
                    "Phone: " + prospectData?.all_applicants[0]?.phone,
                    "Date/Time: " + response.data.data?.formatted_date + " " + response.data.data?.formatted_time,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const updateApplicantData = (data) => {
        let allApplicants = prospectData?.all_applicants?.map((item, index) => {
            if (item?.id === data?.id) {
                return data;
            }
            return { ...item, apt_id: data?.apt_id, apt_no: data?.apt_no };
        });
        setProspectData((prevVal) => {
            return { ...prevVal, all_applicants: allApplicants };
        });
    }

    const sendVerificationLInk = async () => {
        setIsVerifyLinkModalOpen(false);
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/send-verification-link/" + currentApplicantData?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);
            dispatch(communicationChatReload(true));
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const archiveConfirm = async () => {
        setArchiveModalOpen(false);
        setLoading(true);

        let URL = "";

        if (currentApplicantData?.is_archived === 0) {
            URL = process.env.REACT_APP_APPLICANT_API_URL + "v1/prospect-archive/" + currentApplicantData?.id;
        } else {
            URL = process.env.REACT_APP_APPLICANT_API_URL + "v1/prospect-unarchive/" + currentApplicantData?.id;
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.put(URL, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let respData = response.data.data;

            setProspectData((prev) => {
                let all_applicants = prev.all_applicants.map((i) => {
                    if (i.id === currentApplicantData?.id) {
                        return { ...i, is_archived: currentApplicantData?.is_archived ? 0 : 1 };
                    }
                    return i;
                });

                return { ...prev, all_applicants: all_applicants, is_archived: currentApplicantData?.is_archived ? 0 : 1 };
            });

            dispatch(communicationChatReload(true));

            let logData = {
                title: "Prospect is " + (currentApplicantData?.is_archived ? "unarchived" : "archived"),
                description: [
                    "Name: " + respData?.full_name,
                    "Email: " + respData?.email,
                    "Phone: " + respData?.phone,
                    "Property: " + respData?.property_name,
                    "Apartment: " + respData?.apt_no,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const sendApplicationLInk = async () => {
        setApplicationModalOpen(false);
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/send-application-link/" + currentApplicantData?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let respData = response.data.data;

            dispatch(communicationChatReload(true));

            let logData = {
                title: "Application link has been sent successfully.",
                description: [
                    "Name: " + respData?.full_name,
                    "Email: " + respData?.email,
                    "Phone: " + respData?.phone,
                    "Property: " + respData?.property_name,
                    "Apartment: " + respData?.apt_no,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const getIsSumitted = () => {
        let is_submitted = true;

        prospectData?.all_applicants?.map((item) => {
            if (item?.is_submitted === 0) is_submitted = false;

            return null;
        });
        return is_submitted;
    }

    const moveInApplicantChecking = async (event) => {
        if (prospectData?.current_status !== 3) {
            toast.error("Status must be set to Approved before you do this action");
            return false;
        }

        if (prospectData?.no_of_applicants === 2 && prospectData?.no_of_applicants !== prospectData?.all_applicants?.length) {
            toast.error("Second applicant data is not submitted yet.");
            return false;
        }

        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/check-duplicate/" + prospectData?.applicant_id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            let respData = response.data;
            if (respData.status === false) {
                toast.error(respData.message);
            } else {
                setAddLeaseModalOpen(true);
                setLeaseFormData(response.data.data);
            }
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const deleteConfirm = async () => {
        setIsDeleteModalOpen(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.delete(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/" + prospectData?.applicant_id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);
            dispatch(communicationChatReload(true));

            let respData = response.data.data;

            let logData = {
                title: "Prospect is deleted",
                description: [
                    "Name: " + respData?.full_name,
                    "Email: " + respData?.email,
                    "Phone: " + respData?.phone,
                    "Property: " + respData?.property_name,
                    "Apartment: " + respData?.apt_no,
                ],
            };
            AddLogCallAPI(logData, token);

            setOpenProspectDetails(false);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const addTaskList = (data) => {
        setProspectData(prev => {
            return { ...prev, task_list: prev?.task_list.concat(data) }
        });
    }

    const updateTaskList = (data) => {
        setProspectData(prev => {
            return { ...prev, task_list: data }
        });
    }

    const deleteTaskList = (task_id) => {
        setProspectData(prev => {
            let taskList = prev?.task_list.filter(i => i?.id !== task_id);
            return { ...prev, task_list: taskList }
        });
    }

    useEffect(() => {
        if (prospectData?.task_list) {
            let totalTask = prospectData?.task_list?.length;
            let completedTask = prospectData?.task_list?.filter(i => i?.is_checked === 1);
            if (completedTask?.length === 0) {
                setCurrentTaskList(prospectData?.task_list[0].task_name);
            } else {
                setCurrentTaskList(completedTask[completedTask.length - 1].task_name);
            }

            if (totalTask > 0) {
                let percent = (completedTask.length / totalTask) * 100;
                if (parseFloat(percent) > parseInt(percent)) {
                    percent = percent.toFixed(1);
                }
                setCompletedTaskPercent(percent);
            }
        }
    }, [prospectData?.task_list]);

    const applicantVerification = () => {
        let is_checked = true;

        let notCompltedTasks = prospectData?.task_list?.filter(
            (i) => i?.is_checked === 0
        );

        if (notCompltedTasks.length) {
            is_checked = false;
        }

        return is_checked;
    }

    const handleChangeStatus = async (status) => {
        if (status === 3 && !applicantVerification()) {
            toast.error(
                "All tasks must be completed for prospect before you do this action"
            );
            return false;
        }
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/change-status/" + prospectData?.applicant_id + "/" + status, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setProspectData((prevVal) => {
                return { ...prevVal, current_status: status };
            });
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const handleFollowupEditData = (data) => {
        setFollowUpEditData(data);
        setOpenFollowUpModal(true);
    }

    return (<div className={`${styles.ProspectDetailsPanel} ${styles.Open}`}>


        <div className={maxiDetails === true ? `${styles.PanelUnder} ${styles.Open}` : `${styles.PanelUnder}`}>
            {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}
            {!contentLoading && (<>
                <div className={`${styles.PanelCloasesec}`}>
                    <Tooltip title="Maximize"><button className={`${styles.MaximizeBU}`} onClick={OpenMaxiDetails}><ArrowLeft /></button></Tooltip>
                    <Tooltip title="Minimize"><button className={`${styles.MinimizeBU}`} onClick={CloseMaxiDetails}><ArrowRight /></button></Tooltip>
                    <p>Prospect Details</p>
                    <button onClick={(e) => setOpenProspectDetails(false)}><X /></button>
                </div>
                <div className={`${styles.SMProCardHeadRow}`}>
                    <div className={`${styles.SMProCardHead}`}>
                        <div className={prospectData?.all_applicants?.length > 1 ? `${styles.SMProPicMainDubble}` : `${styles.SMProPicMain}`}>
                            {prospectData?.all_applicants?.map((item, index) => {
                                return <Tooltip title={item?.full_name} placement="bottom" key={index}>
                                    <div className={index === currentApplicant ? `${styles.avatar} ${styles.active}` : `${styles.avatar}`} onClick={(e) => setCurrentApplicant(index)}>
                                        {item?.user_avatar !== "" ? (<img src={item?.user_avatar} className={`${styles.roundedcircle}`} alt="" />) : item?.initial !== "?" ? (<p>{item?.initial}</p>) : (<img src="/static/img/DefaultLogo.png" className={`${styles.roundedcircle}`} alt="" />)}
                                    </div>
                                </Tooltip>
                            })}
                        </div>
                        <div className={`${styles.SMProCardHeadCon}`}>
                            <h5>{currentApplicantData?.full_name !== "" ? currentApplicantData?.full_name : "-"}{currentApplicantData?.is_verified === 1 && (<img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" />)}</h5>

                            <div className={`${styles.ProsUserMandateSecBig}`}>
                                <Tooltip title={currentApplicantData?.credit_score !== "" ? "Credit Score - " + currentApplicantData?.credit_score : "Credit Score - N/A"}>
                                    <span className={currentApplicantData?.check_list?.credit_score === 2 ? `${styles.MandateCheckSecBig} ${styles.Fail}` : currentApplicantData?.check_list?.credit_score === 1 ? `${styles.MandateCheckSecBig} ${styles.Active}` : `${styles.MandateCheckSecBig}`}>
                                        <img src="/static/img/credit-score-icon.svg" alt="" />
                                    </span>
                                </Tooltip>
                                <Tooltip title={currentApplicantData?.income_type === "Voucher" ? currentApplicantData?.voucher_amount !== "" ? "Voucher - $" + currentApplicantData?.formatted_voucher_amount : "Voucher - N/A" : currentApplicantData?.income_per_year !== "" ? "Salary - $" + currentApplicantData?.formatted_income_per_year : "Salary - N/A"}>
                                    <span className={currentApplicantData?.check_list?.income === 2 ? `${styles.MandateCheckSecBig} ${styles.Fail}` : currentApplicantData?.check_list?.income === 1 ? `${styles.MandateCheckSecBig} ${styles.Active}` : `${styles.MandateCheckSecBig}`}>
                                        <img src="/static/img/salary-icon.svg" alt="" />
                                    </span>
                                </Tooltip>
                                <Tooltip title={currentApplicantData?.ever_had_bankruptcy !== "" ? "Bankruptcy - " + currentApplicantData?.ever_had_bankruptcy : "Bankruptcy - N/A"}>
                                    <span className={currentApplicantData?.check_list?.bankruptcy === 2 ? `${styles.MandateCheckSecBig} ${styles.Fail}` : currentApplicantData?.check_list?.bankruptcy === 1 ? `${styles.MandateCheckSecBig} ${styles.Active}` : `${styles.MandateCheckSecBig}`}>
                                        <img src="/static/img/bankruptcy-icon.svg" alt="" />
                                    </span>
                                </Tooltip>
                                <Tooltip title={currentApplicantData?.ever_case_filed !== "" ? "Housing Court Cases - " + currentApplicantData?.ever_case_filed : "Housing Court Cases - N/A"}>
                                    <span className={currentApplicantData?.check_list?.housing_court_case === 2 ? `${styles.MandateCheckSecBig} ${styles.Fail}` : currentApplicantData?.check_list?.housing_court_case === 1 ? `${styles.MandateCheckSecBig} ${styles.Active}` : `${styles.MandateCheckSecBig}`}>
                                        <img src="/static/img/court-cases-icon.svg" alt="" />
                                    </span>
                                </Tooltip>
                            </div>
                            <p className={`${styles.HeadConText}`}>Last Updated: {currentApplicantData?.submitted_date}</p>
                            <div className={`${styles.ApprovalSecSmall}`}>
                                {prospectData?.approval_remaining_days !== null && prospectData?.approval_remaining_days > 0 && (prospectData?.current_status !== 3 && prospectData?.current_status !== 4) && <p className={`${styles.ApprovalRemainingText}`}>
                                    <img src="/static/img/clock.svg" alt="" />
                                    {prospectData?.approval_remaining_days > 1 ? prospectData?.approval_remaining_days + ' days ' : prospectData?.approval_remaining_days + ' day '}remaining for approval.
                                </p>}
                                {prospectData?.approval_remaining_days !== null && prospectData?.approval_remaining_days <= 0 && (prospectData?.current_status !== 3 && prospectData?.current_status !== 4) && <p className={`${styles.ApprovalRemainingTextBadge}`}>
                                    <Tooltip title={'Approval Overdue (' + (Math.abs(prospectData?.approval_remaining_days) + 1) + ' days)'}><span className={`${styles.ReferStatusBU} ${styles.StatusBuRed}`}>Approval Overdue</span></Tooltip>
                                </p>}
                            </div>
                            <button className={`${styles.PanelFollowUpBUSM}`} onClick={() => { setOpenFollowUpModal(true); }}>
                                <Bell /> Set Follow-Up
                            </button>
                        </div>
                        <div className={`${styles.SMProCardHeadBuSec}`}>
                            <button className={`${styles.PanelFollowUpBU}`} onClick={() => { setOpenFollowUpModal(true); }}>
                                <Bell /> Set Follow-Up
                            </button>
                            <button className={`${styles.PanelMailBU}`} onClick={(e) => openProspectConversation(e, currentApplicantData)}>
                                <Mail />
                                {currentApplicantData?.unread_no > 0 && (<span>{currentApplicantData?.unread_no}</span>)}
                            </button>
                            <button className={`${styles.PanelMailBU}`} onClick={(e) => setEditModalOpen(true)}>
                                <Edit />
                            </button>
                            <Dropdown>
                                <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic"><MoreVertical /></Dropdown.Toggle>

                                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                    {/* <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setEditModalOpen(true)}>
                                        <Edit /> Edit
                                    </Dropdown.Item> */}
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.ForSmallReso}`} onClick={(e) => setEditModalOpen(true)}>
                                        <Edit /> Edit Prospect
                                    </Dropdown.Item>
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.ForSmallReso}`} onClick={(e) => openProspectConversation(e, currentApplicantData)}>
                                        <Mail /> SMS Chat
                                    </Dropdown.Item>
                                    {(prospectData?.is_prospect_applied === 1) & getIsSumitted() ? (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={moveInApplicantChecking.bind(this)}>
                                        <ChevronsLeft /> Move-in Tenant
                                    </Dropdown.Item>) : null}
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddTourModalOpen(true); setTourTimeSlotError(""); setEditTourData(null); setTourAptSlotError(""); }}>
                                        <Flag /> Add Tour
                                    </Dropdown.Item>
                                    {currentApplicantData?.is_payment === 0 && currentApplicantData?.is_applied === 1 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setIsVerifyLinkModalOpen(false); setIsDeleteModalOpen(false); setArchiveModalOpen(false); setApplicationModalOpen(true); setIsConnectAccountModalOpen(false); }}>
                                        <Send /> Send Application Link
                                    </Dropdown.Item>)}
                                    {currentApplicantData?.is_verified === 0 && (<Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setIsVerifyLinkModalOpen(true); setIsDeleteModalOpen(false); setArchiveModalOpen(false); setIsConnectAccountModalOpen(false); }}>
                                        <CheckCircle /> Send Verification Link
                                    </Dropdown.Item>)}
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setIsVerifyLinkModalOpen(false); setIsDeleteModalOpen(false); setArchiveModalOpen(false); setIsConnectAccountModalOpen(true); }}>
                                        <Link /> Connect Accounts
                                    </Dropdown.Item>
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setIsVerifyLinkModalOpen(false); setIsDeleteModalOpen(false); setArchiveModalOpen(true); setIsConnectAccountModalOpen(false); }}>
                                        <Archive />{" "}{currentApplicantData?.is_archived ? "Unarchive" : "Archive"}
                                    </Dropdown.Item>
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setIsVerifyLinkModalOpen(false); setArchiveModalOpen(false); setIsDeleteModalOpen(true); setIsConnectAccountModalOpen(false); }}>
                                        <Trash2 /> Delete
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        {!openStepperDetails && <div className={`${styles.SmallStepArea}`}>
                            <p className={`${styles.StepTitle}`}>{currentTaskList}</p>
                            <div className={`${styles.StepperTrack}`} style={{ width: '100%', backgroundColor: '#eff2fa', height: '6px', borderRadius: '12px', margin: '12px 0 10px', overflow: 'hidden', position: 'relative' }}>
                                <div className={`${styles.StepperBar}`} style={{ width: completedTaskPercent + '%', backgroundColor: '#502688', height: '100%', zIndex: 1, position: 'relative' }}></div>
                            </div>
                            <div className={`${styles.StepperProgressSec}`}>
                                <p className={`${styles.StepperProgressText}`}>{completedTaskPercent}%</p>
                                <p className={`${styles.StepperDeBU}`} onClick={(e) => setOpenStepperDetails(true)}>View Details</p>
                            </div>
                        </div>}
                    </div>
                    {openStepperDetails && (<div className={`${styles.StepperArea}`}>
                        <button className={`${styles.detailStepperBU}`} onClick={(e) => setOpenStepperDetails(false)}><X /></button>
                        {prospectData?.task_list?.map(item => {
                            return (<div className={item?.is_checked === 1 ? `${styles.StepperCard} ${styles.Completed}` : `${styles.StepperCard}`}>
                                <div className={`${styles.StepIcon}`}><Check /></div>
                                <div className={`${styles.StepTitle}`}><span>{item?.task_name}</span></div>
                            </div>);
                        })}
                    </div>)}
                    <div className={`${styles.SMProCardHeadProCon}`}>
                        <div className={`${styles.HeadConCard}`}>
                            <p className={`${styles.ProsDeTitle}`}>Email:</p>
                            {currentApplicantData?.email !== "" ? (<CopyToClipboard text={currentApplicantData?.email} onCopy={() => setEmailCopied(true)}>
                                <Tooltip title={emailCopied ? "Copied" : "Copy"}>
                                    <p className={`${styles.ProsDeCon} ${styles.Link}`}><Copy /><span>{currentApplicantData?.email}</span></p>
                                </Tooltip>
                            </CopyToClipboard>) : (<p className={`${styles.ProsDeCon}`}>{"-"}</p>)}
                        </div>
                        <div className={`${styles.HeadConCard}`}>
                            <p className={`${styles.ProsDeTitle}`}>Phone:</p>
                            <Tooltip title="Start a voice call">
                                <p className={`${styles.ProsDeCon} ${styles.Link}`} onClick={(e) => { e.preventDefault(); initiateVoiceCall(); }}><PhoneCall /><span>{currentApplicantData?.phone}</span></p>
                            </Tooltip>
                        </div>
                        <div className={`${styles.HeadConCard}`}>
                            <p className={`${styles.ProsDeTitle}`}>Property:</p>
                            <LinkTo className={`${styles.ProsDeCon} ${styles.Link}`} to={"/properties/details/" + currentApplicantData?.property_id}><span>{currentApplicantData?.property_name}</span></LinkTo>
                        </div>
                        <div className={`${styles.HeadConCard}`}>
                            <p className={`${styles.ProsDeTitle}`}>Apartment:</p>
                            <p className={`${styles.ProsDeCon}`}><span>{currentApplicantData?.apt_no && currentApplicantData?.apt_no !== "" ? currentApplicantData?.apt_no : "-"}</span></p>
                        </div>
                    </div>
                </div>
                <div className={`${styles.SMBigSideHead}`}>
                    <h5>Activities</h5>
                    {prospectData?.is_archived === 0 && (prospectData?.current_status > 0 ? (<div>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect:update") > -1 && (<Dropdown>
                            {prospectData?.current_status === 1 && (<Dropdown.Toggle id="dropdown-basic" className={`${styles.ReferStatusBU} ${styles.Prequalified}`}>
                                Applied
                                <ChevronDown className={`${styles.DownArrowStatus}`} />
                            </Dropdown.Toggle>)}

                            {prospectData?.current_status === 2 && (<Dropdown.Toggle id="dropdown-basic" className={`${styles.ReferStatusBU} ${styles.StatusBuYellow}`}>
                                Screened
                                <ChevronDown className={`${styles.DownArrowStatus}`} />
                            </Dropdown.Toggle>)}

                            {prospectData?.current_status === 3 && (<Dropdown.Toggle id="dropdown-basic" className={`${styles.ReferStatusBU} ${styles.Approved}`}>
                                Approved
                                <ChevronDown className={`${styles.DownArrowStatus}`} />
                            </Dropdown.Toggle>)}

                            {prospectData?.current_status === 4 && (<Dropdown.Toggle id="dropdown-basic" className={`${styles.ReferStatusBU} ${styles.StatusBuRed}`}>
                                Declined
                                <ChevronDown className={`${styles.DownArrowStatus}`} />
                            </Dropdown.Toggle>)}

                            <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                <Dropdown.Item className={`${styles.EditActionsBUListItemSmall}`} onClick={(e) => setIsAppliedModalOpen(true)}>Applied</Dropdown.Item>
                                <Dropdown.Item className={`${styles.EditActionsBUListItemSmall}`} onClick={(e) => setIsScreenedModalOpen(true)}>Screened</Dropdown.Item>
                                <Dropdown.Item className={`${styles.EditActionsBUListItemSmall}`} onClick={(e) => setIsApprovedModalOpen(true)}>Approved</Dropdown.Item>
                                <Dropdown.Item className={`${styles.EditActionsBUListItemSmall}`} onClick={(e) => setIsDeclinedModalOpen(true)}>Declined</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>)}
                    </div>) : (<div>
                        <span className={`${styles.ReferStatusBUNotApplied}`}>Not Applied</span>
                    </div>))}
                    {currentApplicantData?.afford_amount !== "" && currentApplicantData?.check_list?.income === 2 && (<span className={`${styles.ReferStatusBU} ${styles.StatusBuRed}`}>Afford: ${currentApplicantData?.afford_amount}</span>)}
                    {currentApplicantData?.afford_amount !== "" && currentApplicantData?.check_list?.income === 1 && (<span className={`${styles.ReferStatusBU} ${styles.Approved}`}>Afford: ${currentApplicantData?.afford_amount}</span>)}
                    {prospectData?.approval_remaining_days !== null && prospectData?.approval_remaining_days > 0 && (prospectData?.current_status !== 3 && prospectData?.current_status !== 4) && <p className={`${styles.ApprovalRemainingText}`}>
                        <img src="/static/img/clock.svg" alt="" />
                        {prospectData?.approval_remaining_days > 1 ? prospectData?.approval_remaining_days + ' days ' : prospectData?.approval_remaining_days + ' day '}remaining for approval.
                    </p>}
                    {prospectData?.approval_remaining_days !== null && prospectData?.approval_remaining_days <= 0 && (prospectData?.current_status !== 3 && prospectData?.current_status !== 4) && <p className={`${styles.ApprovalRemainingTextBadge}`}>
                        <Tooltip title={'Approval Overdue (' + (Math.abs(prospectData?.approval_remaining_days) + 1) + ' days)'}><span className={`${styles.ReferStatusBU} ${styles.StatusBuRed}`}>Approval Overdue</span></Tooltip>
                    </p>}
                </div>
                <div className={`${styles.SMBigSideBody} TabMainClientProfile ClientDetails`}>
                    <SimpleTabs
                        applicant_id={prospectData?.applicant_id}
                        prospectData={prospectData}
                        currentApplicantData={currentApplicantData}
                        addNoteData={addNoteData.bind(this)}
                        editNoteData={editNoteData.bind(this)}
                        deleteNoteData={deleteNoteData.bind(this)}
                        setSnackbarMsg={setSnackbarMsg.bind(this)}
                        setSnackbarOpen={setSnackbarOpen.bind(this)}
                        setIsConnectAccountModalOpen={setIsConnectAccountModalOpen.bind(this)}
                        updateFileList={updateFileList.bind(this)}
                        updateTourList={updateTourList.bind(this)}
                        setAddTourModalOpen={setAddTourModalOpen.bind(this)}
                        setEditTourData={setEditTourData.bind(this)}
                        setTourTimeSlotError={setTourTimeSlotError.bind(this)}
                        updateMandatoryChecks={updateMandatoryChecks.bind(this)}
                        setLoading={setLoading.bind(this)}
                        updateTaskList={updateTaskList.bind(this)}
                        addTaskList={addTaskList.bind(this)}
                        deleteTaskList={deleteTaskList.bind(this)}
                        followUpList={followUpList}
                        setFollowUpList={setFollowUpList}
                        setFollowUpEditData={handleFollowupEditData}
                        setOpenFollowUpModal={setOpenFollowUpModal.bind(this)}
                    />
                </div>
            </>)}
        </div>

        <Dialog
            open={isConnectAccountModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setIsConnectAccountModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to send connect account link?
                <button onClick={(e) => setIsConnectAccountModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">Send a connect account link via SMS. This link will allow to connect prospect bank account.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => sendBankAccountLInk(e)} className="CancelPopupBU">Confirm</Button>
                <Button onClick={(e) => setIsConnectAccountModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={addTourModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setAddTourModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPopUs"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setAddTourModalOpen(false)}><ArrowLeft /></button>
                {editTourData?.id > 0 ? "Update Tour" : "Add Tour"}
                <button onClick={(e) => setAddTourModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter AddTour`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Apartment*</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={"Apartment*"}
                            value={selectedApartment}
                            onChange={(e) => setSelectedApartment(e.target.value)}
                        >
                            {apartments?.map((item) => {
                                return (<MenuItem key={item?.value} value={item?.value}>{item?.label}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                    <p className={`${styles.AddTourErrorMessage}`}>{tourAptSlotError !== "" && tourAptSlotError}</p>
                </div>
                <p className={`${styles.AddTourPopTT}`}>Select Tour Date and Time</p>
                <div className={`${styles.ModalFormGroup} ModalFormGroup`}>
                    <div className={`${styles.AddTourModal} AddTourModal`}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <StaticDatePicker
                                orientation="landscape"
                                defaultValue={selectedTourDate}
                                minDate={dayjs()}
                                onChange={(e) => setSelectedTourDate(e)}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className={`${styles.AddTourTimeArea}`}>
                        <p className={`${styles.TimeSlotTitle}`}>{dayjs(selectedTourDate).format("dddd, MMMM D")}</p>
                        <p className={`${styles.AddTourErrorMessage}`}>{tourTimeSlotError !== "" && tourTimeSlotError}</p>
                        <AddTourTileSlot
                            setSelectedTourTime={setSelectedTourTime.bind(this)}
                            selectedTourDate={selectedTourDate}
                            selectedTourTime={selectedTourTime}
                            selectProperty={prospectData?.property_id}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => setAddTourModalOpen(false)} className="CancelPopupBU">Cancel</Button>
                {editTourData?.id > 0 ? (<Button className="SubmitPopupBU" onClick={updateTour}>Update</Button>) : (<Button className="SubmitPopupBU" onClick={addTour}>Add</Button>)}
            </DialogActions>
        </Dialog>

        <Dialog
            open={editModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setEditModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setEditModalOpen(false)}><ArrowLeft /></button>
                <span>Edit Prospect</span>
                <button onClick={(e) => setEditModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <EditPropsectNew
                    setEditModalOpen={setEditModalOpen.bind(this)}
                    setLoading={setLoading.bind(this)}
                    setSnackbarMsg={setSnackbarMsg.bind(this)}
                    setSnackbarOpen={setSnackbarOpen.bind(this)}
                    prospectData={currentApplicantData}
                    updateApplicantData={updateApplicantData.bind(this)}
                />
            </DialogContent>
        </Dialog>

        <Dialog
            open={isVerifyLinkModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setIsVerifyLinkModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to send verification link?
                <button onClick={(e) => setIsVerifyLinkModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">Send a verification link via SMS. This link will allow to verify prospect account.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => sendVerificationLInk(e)} className="CancelPopupBU">Confirm</Button>
                <Button onClick={(e) => setIsVerifyLinkModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={archiveModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setArchiveModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to{" "}{currentApplicantData?.is_archived ? "unarchive" : "archive"} the Prospect Record?
                <button onClick={(e) => setArchiveModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">{currentApplicantData?.is_archived ? "The Prospect Record will be unarchived immediately. You can archive it at any time." : "The Prospect Record will be archived immediately. You can unarchive it at any time."}</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="CancelPopupBU" onClick={(e) => archiveConfirm()}>{currentApplicantData?.is_archived ? "Unarchive" : "Archive"}</Button>
                <Button className="SubmitPopupBU" onClick={(e) => setArchiveModalOpen(false)}>Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={applicationModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setApplicationModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to send application link?
                <button onClick={(e) => setApplicationModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">Send a application link via SMS. This link will allow to continue application.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => sendApplicationLInk(e)} className="CancelPopupBU">Confirm</Button>
                <Button onClick={(e) => setApplicationModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={addLeaseModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setAddLeaseModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp CustomWidthPopUs"
        >
            <LeaseForm
                setAddLeaseModalOpen={setAddLeaseModalOpen.bind(this)}
                leaseFormData={leaseFormData}
                applicant_id={prospectData?.applicant_id}
                setLoading={setLoading.bind(this)}
                setSnackbarMsg={setSnackbarMsg.bind(this)}
                setSnackbarOpen={setSnackbarOpen.bind(this)}
            />
        </Dialog>

        <Dialog
            open={isDeleteModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setIsDeleteModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to delete the Prospect Record?
                <button onClick={(e) => setIsDeleteModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The Prospect Record will be removed immediately.You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={deleteConfirm.bind(this)} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setIsDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={isAppliedModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setIsAppliedModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to Applied the Prospect Record?
                <button onClick={(e) => setIsAppliedModalOpen(false)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">
                            Once Applied, The prospect record status will be set to
                            'Applied'.
                        </label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    className="CancelPopupBU"
                    onClick={(e) => setIsAppliedModalOpen(false)}
                >
                    Cancel
                </Button>
                <Button
                    onClick={(e) => {
                        setIsAppliedModalOpen(false);
                        handleChangeStatus(1);
                    }}
                    className="SubmitPopupBU"
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={isScreenedModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setIsScreenedModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to Screened the Prospect Record?
                <button onClick={(e) => setIsScreenedModalOpen(false)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">
                            Once Screened, The prospect record status will be set to
                            'Screened'.
                        </label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    className="CancelPopupBU"
                    onClick={(e) => setIsScreenedModalOpen(false)}
                >
                    Cancel
                </Button>
                <Button
                    onClick={(e) => {
                        setIsScreenedModalOpen(false);
                        handleChangeStatus(2);
                    }}
                    className="SubmitPopupBU"
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={isApprovedModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setIsApprovedModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to Approve the Prospect Record?
                <button onClick={(e) => setIsApprovedModalOpen(false)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">
                            Once approved, the Prospect will receive an automated SMS
                            notification. This action is permanent.
                        </label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    className="CancelPopupBU"
                    onClick={(e) => setIsApprovedModalOpen(false)}
                >
                    Cancel
                </Button>
                <Button
                    onClick={(e) => {
                        setIsApprovedModalOpen(false);
                        handleChangeStatus(3);
                    }}
                    className="SubmitPopupBU"
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={isDeclinedModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setIsDeclinedModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to decline the Prospect Record?
                <button onClick={(e) => setIsDeclinedModalOpen(false)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">
                            Declining sends an immediate email notification. This action is
                            permanent.
                        </label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    className="CancelPopupBU"
                    onClick={(e) => setIsDeclinedModalOpen(false)}
                >
                    Cancel
                </Button>
                <Button
                    onClick={(e) => {
                        setIsDeclinedModalOpen(false);
                        handleChangeStatus(4);
                    }}
                    className="SubmitPopupBU"
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openFollowUpModal}
            fullWidth
            maxWidth="sm"
            onClose={(e) => setOpenFollowUpModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                <span>Set Follow-Up</span>
                <button onClick={(e) => setOpenFollowUpModal(false)}>
                    <X />
                </button>
            </DialogTitle>
            <DialogContent>
                <AddFollowUp
                    setOpenFollowUpModal={setOpenFollowUpModal}
                    setLoading={setLoading}
                    setSnackbarOpen={setSnackbarOpen}
                    setSnackbarMsg={setSnackbarMsg}
                    prospect_id={prospect_id}
                    setAllData={setFollowUpList}
                    followUpEditData={followUpEditData}
                    setFollowUpEditData={setFollowUpEditData}
                />
            </DialogContent>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

    </div >)
}

export default ProspectDetails;